import React from "react";

interface ArrowProps {
  size?: number;
}

export const CircularArrowUp: React.FC<ArrowProps> = ({ size = 20 }) => (
  <div className="relative inline-block">
    {/* Light mode: filled circle */}
    <svg
      className="block dark:hidden"
      width={size}
      height={size}
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 3.22559C6.61522 3.22559 2.25 7.59081 2.25 12.9756C2.25 18.3604 6.61522 22.7256 12 22.7256C17.3848 22.7256 21.75 18.3604 21.75 12.9756C21.75 7.59081 17.3848 3.22559 12 3.22559ZM12.5303 8.69526C12.3897 8.5546 12.1989 8.47559 12 8.47559C11.8011 8.47559 11.6103 8.5546 11.4697 8.69526L8.46967 11.6953C8.17678 11.9881 8.17678 12.463 8.46967 12.7559C8.76256 13.0488 9.23744 13.0488 9.53033 12.7559L11.25 11.0362L11.25 16.7256C11.25 17.1398 11.5858 17.4756 12 17.4756C12.4142 17.4756 12.75 17.1398 12.75 16.7256L12.75 11.0362L14.4697 12.7559C14.7626 13.0488 15.2374 13.0488 15.5303 12.7559C15.8232 12.463 15.8232 11.9881 15.5303 11.6953L12.5303 8.69526Z"
        fill="#22C55E"
      />
    </svg>
    {/* Dark mode: ring with arrow */}
    <svg
      className="hidden dark:block"
      width={size}
      height={size}
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="12"
        cy="12.9756"
        r="9"
        stroke="#22C55E"
        strokeWidth="1.5"
        fill="transparent"
      />
      <path
        d="M12.5303 8.69526C12.3897 8.5546 12.1989 8.47559 12 8.47559C11.8011 8.47559 11.6103 8.5546 11.4697 8.69526L8.46967 11.6953C8.17678 11.9881 8.17678 12.463 8.46967 12.7559C8.76256 13.0488 9.23744 13.0488 9.53033 12.7559L11.25 11.0362L11.25 16.7256C11.25 17.1398 11.5858 17.4756 12 17.4756C12.4142 17.4756 12.75 17.1398 12.75 16.7256L12.75 11.0362L14.4697 12.7559C14.7626 13.0488 15.2374 13.0488 15.5303 12.7559C15.8232 12.463 15.8232 11.9881 15.5303 11.6953L12.5303 8.69526Z"
        fill="#22C55E"
      />
    </svg>
  </div>
);

export const CircularArrowDown: React.FC<ArrowProps> = ({ size = 20 }) => (
  <div className="relative inline-block">
    {/* Light mode: filled circle */}
    <svg
      className="block dark:hidden"
      width={size}
      height={size}
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 3.22559C6.61522 3.22559 2.25 7.59081 2.25 12.9756C2.25 18.3604 6.61522 22.7256 12 22.7256C17.3848 22.7256 21.75 18.3604 21.75 12.9756C21.75 7.59081 17.3848 3.22559 12 3.22559ZM11.4697 17.2559C11.6103 17.3965 11.8011 17.4756 12 17.4756C12.1989 17.4756 12.3897 17.3965 12.5303 17.2559L15.5303 14.2559C15.8232 13.963 15.8232 13.4881 15.5303 13.1953C15.2374 12.9024 14.7626 12.9024 14.4697 13.1953L12.75 14.9149L12.75 9.22559C12.75 8.81138 12.4142 8.47559 12 8.47559C11.5858 8.47559 11.25 8.81138 11.25 9.22559L11.25 14.9149L9.53033 13.1953C9.23744 12.9024 8.76256 12.9024 8.46967 13.1953C8.17678 13.4881 8.17678 13.963 8.46967 14.2559L11.4697 17.2559Z"
        fill="#EF4444"
      />
    </svg>
    {/* Dark mode: ring with arrow */}
    <svg
      className="hidden dark:block"
      width={size}
      height={size}
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="12"
        cy="12.9756"
        r="9"
        stroke="#EF4444"
        strokeWidth="1.5"
        fill="transparent"
      />
      <path
        d="M11.4697 17.2559C11.6103 17.3965 11.8011 17.4756 12 17.4756C12.1989 17.4756 12.3897 17.3965 12.5303 17.2559L15.5303 14.2559C15.8232 13.963 15.8232 13.4881 15.5303 13.1953C15.2374 12.9024 14.7626 12.9024 14.4697 13.1953L12.75 14.9149L12.75 9.22559C12.75 8.81138 12.4142 8.47559 12 8.47559C11.5858 8.47559 11.25 8.81138 11.25 9.22559L11.25 14.9149L9.53033 13.1953C9.23744 12.9024 8.76256 12.9024 8.46967 13.1953C8.17678 13.4881 8.17678 13.963 8.46967 14.2559L11.4697 17.2559Z"
        fill="#EF4444"
      />
    </svg>
  </div>
);
